<template>
  <div class="educa_manage_wrap" v-loading="loading">
  	<div class="educa_manage_header">
      <h2>开课计划</h2>
    </div>
  	<div class="educa_manage_table" v-if="flag">
      <div class="title_top">
        <h1>{{coursePlan}}</h1>
        <p>注意：请核对班级信息是否正确，如果没有班级信息或信息有误，</p>
        <p>请在‘学生管理’中重新编辑上传学生名单</p>
      </div>
      <n-table
        ref="plan_manage"
        :tableData="tableData"
        :tableHeader="PlanTableHeader"
        :ISChangeCheckout="false"
        :TableHeight="TableHeight"
        @operation="operation"
      ></n-table>
	    <!-- 导入开课计划弹出 -->
	    <el-dialog title="开课上机计划导入" :visible.sync="centerDialogVisible" :close-on-press-escape="false" :close-on-click-modal="false" width="600px" :show-close="false" :before-close="handleCloseUpload">
	      <div class="training-site upload-content" v-loading="uploading" element-loading-text="开机上课计划导入中">
	        <div class="left">
	            <el-input readonly v-model="fileName"></el-input>
	            <span class="on" v-if="fileName" @click="delFile()">删除</span>
	            <span class="off" v-else>删除</span>
	            <p><i>*</i>注意：</p>
	            <p>1、请使用模板文件导入上机计划。<a target="view_frame" @click="jump()">下载模板</a></p>
	            <p>2、请在模板中选择上机时段，并填写数字1。</p>
	            <p>3、每个时段为1课时，可选总课时数{{planLessonCount}}，如上传失败</p>
	            <p>请确认课时数是否超出</p>
	        </div>
	        <div class="right">
	            <el-upload
	                ref="upload"
	                class="upload-demo"
	                action="https://jsonplaceholder.typicode.com/posts/"
	                :before-upload="beforeUpload"
	                :show-file-list=false
	                :limit="1"
	                :on-exceed="handleExceed"
	                :file-list="fileList">
	                <img src="/static/images/wenjianjia.png" alt="">
	                <p>选择文件</p>
	            </el-upload>
	        </div>
	      </div>
	      <span slot="footer" class="dialog-footer">
	        <el-button @click="handleTrainingeSites(false)" :loading="uploading">取 消</el-button>
	        <el-button type="primary" @click="handleTrainingeSites(true)" :loading="uploading">保 存</el-button>
	      </span>
	    </el-dialog>
	    <!--查看开课计划-->
	    <el-dialog title="开课上机计划查看" :visible.sync="centersDialogVisible" :close-on-press-escape="false" :close-on-click-modal="false" width="600px" :show-close="false">
	      <div class="training-site">
	        <el-table
		        :data="coursePlanData"
		        style="width: 100%"
		        height="300px"
		        class="collegeTable"
		        :empty-text="empty"
		      >
		        <el-table-column type="index" width="100" label="序号"></el-table-column>
		        <el-table-column prop="date" label="日期"></el-table-column>
		        <el-table-column prop="time" label="时段"></el-table-column>
		      </el-table>
	      </div>
	      <span slot="footer" class="dialog-footer">
	        <el-button @click="handleClose()">关闭</el-button>
	      </span>
	    </el-dialog>
  	</div>
  	<div class="blank" v-if="!flag">
  		<img src="/static/images/kong.png"/>
      <p>暂无开课计划</p>
  	</div>
  </div>
</template>
<script>
import * as api from "@/api/educationalApi"
import { PlanTableHeader } from "../../../global/table_header_data";
export default {
  data() {
    return {
      tableData: [],
      windowHeight: window.innerHeight, // 表格高度根据窗口高度来决定
      empty: "暂无数据",
      centerDialogVisible: false,
      centersDialogVisible: false,
      fileList: [],
      fileName: "",
      file:'',
      loading: true,
      uploading:false,
      schoolId:sessionStorage.getItem('deptId'),
      userId:sessionStorage.getItem('userId'),
      classId:'',
      coursePlanData:[],
      coursePlan:'',
      planId:'',
      planLessonCount:'',
      flag:true,
      PlanTableHeader: PlanTableHeader,
      TableHeight: "0px",
    };
  },
  created() {
    this.startInto();
  },
  methods: {
  	// 初始化
  	startInto(){
      api.getPlanInfo().then(res=>{
  			if(res.code == 0){
  				if(res.data.length){
  					this.flag = true;
  					this.coursePlan = res.data[0].planName;
	  				this.planId = res.data[0].id;
	  				this.planLessonCount = res.data[0].planLessonCount;
	  				// this.getTeachingClass();
            this.getCoursePlanList();
  				}else{
  					this.flag = false;
  					this.loading = false;
  				}
  			}else{
          this.$messageError(res.msg)
        }
  		});
  	},
  	getTeachingClass(){
      api.initTeachingClass(this.schoolId,this.userId).then(res=>{
  			if(res.code == 0){
  				this.getCoursePlanList();
  			}else{
  				this.$messageError("创建班级失败！");
  			}
  		}).catch(error=>{
  			console.log(error);
  		});
  	},
    // 开课计划列表
    getCoursePlanList() {
      let that = this
      api.getCoursePlanList(this.schoolId,this.planId).then(res => {
        if(res.code == 0){
          that.tableData = []
          that.TableHeight = "300px"
          if(res.data.length>0){
            res.data.forEach((v,i)=>{
              let obj = v
              // let num = (listArr.current-1) * listArr.size + i+1
              let num = i+1
              let isUploadStr = ""
              let studentCount = ""
              isUploadStr = v.isUpload==1 ? '已导入' : '未导入';
              studentCount = v.studentCount ? v.studentCount : '——';
              that.$set(obj, 'isUploadStr', isUploadStr)
              that.$set(obj, 'studentCountStr', studentCount)
              that.$set(obj, 'num', num)
              that.tableData.push(obj)
            })
            this.TableHeight = (that.windowHeight - 266) + 'px';
          }
        }else{
          this.$messageError(res.msg);
          return
        }
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
      });
    },
    // 导入开课计划
    uploadRow(row){
    	this.centerDialogVisible = true;
    	this.classId = row.classId;
    	this.uploading = false;
    	this.fileName = '';
    },
    // 查看开课计划
    seeRow(row){
      this.centersDialogVisible = true;
      api.previewPlan(this.schoolId,row.classId,this.planId).then(res=>{
    		if(res.code == 0){
    			this.coursePlanData = res.data;
    		}else{
          this.$messageError(res.msg)
        }
    	}).catch(error=>{
    		console.log(error);
    	})
    },
    // 删除开课计划
    delRow(row) {
      this.$confirm("是否确认删除"+row.className+"行政班的开课计划?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        api.deletePlan(this.schoolId,row.classId,this.planId).then(res => {
          if (res.code === "0") {
            this.$messageSuccess("删除成功");
            this.loading = true;
            this.getCoursePlanList();
          } else {
            this.$messageError("删除失败");
          }
        })
        .catch(error => {
          console.log(error);
        });
      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });
    },
    // table-操作
    operation(type, RowData) {
      if(type=='import'){
        this.uploadRow(RowData)
      }else if(type=='preview'){
        this.seeRow(RowData)
      }else if(type=='delete'){
        this.delRow(RowData)
      }
    },
    beforeUpload(file){
      this.$refs.upload.clearFiles();
      var testmsg=file.name.substring(file.name.lastIndexOf('.')+1)
      const extension2 = testmsg === 'xlsx'
      if(!extension2) {
          this.$messageWarning('上传文件只能是xlsx格式!');
      }else {
          let fd = new FormData();
          fd.append('file', file);
          this.file = fd;
          this.fileName = file.name;
      }
      return extension2
    },
    // 导入开课计划保存
    handleTrainingeSites(type){
      if(type){
        if(this.fileName){
          this.uploading = true;
          api.importPlan(this.schoolId,this.classId,this.planId,this.file).then(res=>{
            if(res.code == '0'){
              this.loading = true;
              this.getCoursePlanList();
              this.centerDialogVisible = false;
              this.$messageSuccess(res.msg);
              this.uploading = false;
            }else{
              this.$messageError(res.msg);
              this.uploading = false;
            }
          })
        }else{
          this.$messageError('请导入名单后再保存');
        }
      }else{
        this.$refs.upload.clearFiles();
        this.centerDialogVisible = false;
      }
    },
    handleExceed(files, fileList) {
      this.$refs.upload.clearFiles();
    },
    // 删除导入文件
    delFile(){
      this.fileName = '';
      this.$refs.upload.clearFiles();
    },
    jump(){
      let url = process.env.BAK_NAME+'/management/excel/%E4%B8%8A%E6%9C%BA%E8%AF%BE%E6%97%B6%E6%A8%A1%E6%9D%BF.xlsx';
      this.$downloadFun(url)
    },
    handleCloseUpload(done){
      done();
      this.$refs.upload.clearFiles();
    },
    // 关闭开课计划查看
    handleClose(){
    	this.centersDialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.educa_manage_wrap {
  .educa_manage_table{
    .title_top {
    	margin: 0 auto 10px;
    	text-align: center;
      padding-top: 20px;
      box-sizing: border-box;
    	p {
    		line-height: 24px;
    	}
    	h1 {
    		font-size: 16px;
    		margin-bottom: 26px;
    	}
    }
  }
  .blank {
  	margin-top: 16%;
  	text-align: center;
  }
  .training-site {
    .top {
      height: 110px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-wrap:wrap;
      border-bottom: 1px solid #EBEBEB;
    }
    .bottom {
      height: 55px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 16px;
    }
    /deep/ .el-input__inner {
      width: 220px;
      height: 34px;
      line-height: 34px;
    }
    /deep/ .el-form-item {
      margin-bottom: 15px;
    }
    /deep/ .el-input--suffix {
      width: 96px;
    }
    /deep/ .el-form-item__error {
      top: 89%;
    }
    /deep/ .el-col-6 {
      width: 29%;
    }
  }
  .upload-content {
    padding: 90px;
    display: flex;
    justify-content: space-between;
    .el-input {
      width: 240px;
      margin-bottom: 16px;
    }
    .left {
      position: relative;
      p {
          font-size: 12px;
          color: #999999;
          margin-bottom: 6px;
          i{
              color: #E34646;
          }
          a {
              cursor: pointer;
              color: #5397F7;
              &:hover {
                  text-decoration: underline;
              }
          }
      }
      span {
          position: absolute;
          width:64px;
          height:34px;
          line-height: 34px;
          text-align: center;
          border-radius:0px 4px 4px 0px;
          right: 7px;
          top: 0;
          color: #FFFFFF;
      }
      .off {
          background:rgba(226,226,226,1);
      }
      .on {
          cursor: pointer;
          background: #5397F7
      }
    }
    .right {
        width:88px;
        height:88px;
        text-align: center;
        background:rgba(255,255,255,1);
        border:1px solid rgba(226,226,226,1);
        border-radius:4px;
        img {
            display: inline-block;
            width: 32px;
            height: 32px;
            margin-top: 16px;
            margin-bottom: 4px;
        }
        p {
            color: #999999;
        }
        .upload-demo {
            width: 100%;
            height: 100%;
        }
    }
}
  .content {
    height: 260px;
    border:1px solid rgba(226,226,226,1);
    border-radius: 4px;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 48px;
      border-bottom: 1px solid rgba(226,226,226,1);
      padding: 0 10px;
      span {
        font-size: 14px;
        color: #999999;
      }
    }
    .bottom {
      height: 210px;
      padding: 0 12px;
      overflow-y: auto;
      /deep/ .el-tree {
        margin: 9px 0;
      }
      /deep/ .el-tree-node__content {
        height: 32px;
        border-radius:4px;
        &:hover {
          background: #5397F7;
          .el-tree-node__label {
            color: #fff;
          }
          .el-checkbox__inner {
            border-color:#fff;
          }
        }
      }
    }
  }
  .tishi {
    position: absolute;
    top: 2px;
    right: -24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_educa_module/educa/classPlan/coursePlan.vue